module.exports = __webpack_public_path__ + "media/lift-music.011ca1aa.mp3";